import React from 'react';
import { ClearOutlined } from '@ant-design/icons';
import { translator } from 'core/localization';
import { AntButton } from 'controls/react/ant/antButton';
import { AntPopconfirm } from 'controls/react/ant/antPopconfirm';
import { apiFetch } from 'framework/api';
import { clearUserSettings } from '../../api';

const i = translator({
	'Clear all user settings': {
		no: 'Fjern alle brukerinnstillinger',
	},
	'Clear all user settings. For instance all default filters, window size and positions are reverted.': {
		no: 'Fjerner alle brukerinnstillinger. F.eks alle standard filtere, vindu størrelse og posisjoner er tilbakestilt.',
	},
	'Are you sure?': {
		no: 'Er du sikker?',
	},
});

export const ClearUserSettings = () => {
	const [clearing, setClearing] = React.useState(false);

	const clearSettings = React.useCallback(async () => {
		setClearing(true);
		try {
			await apiFetch(clearUserSettings());
		} finally {
			setClearing(false);
		}
	}, []);

	return (
		<AntPopconfirm title={i('Are you sure?')} type={'question'} onConfirm={clearSettings}>
			<AntButton
				type={'link'}
				loading={clearing}
				icon={<ClearOutlined />}
				title={i(
					'Clear all user settings. For instance all default filters, window size and positions are reverted.',
				)}
			>
				{i('Clear all user settings')}
			</AntButton>
		</AntPopconfirm>
	);
};
